import { render, staticRenderFns } from "./SearchPlaces.vue?vue&type=template&id=edd39f3c&scoped=true&"
import script from "./SearchPlaces.vue?vue&type=script&lang=js&"
export * from "./SearchPlaces.vue?vue&type=script&lang=js&"
import style0 from "./SearchPlaces.vue?vue&type=style&index=0&id=edd39f3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd39f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edd39f3c')) {
      api.createRecord('edd39f3c', component.options)
    } else {
      api.reload('edd39f3c', component.options)
    }
    module.hot.accept("./SearchPlaces.vue?vue&type=template&id=edd39f3c&scoped=true&", function () {
      api.rerender('edd39f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/products/SearchPlaces.vue"
export default component.exports